import { __makeTemplateObject } from "tslib";
import styled from 'styled-components';
import { fontFamily, gridSize } from '@atlaskit/theme/constants';
import { multiply } from '@atlaskit/theme/math';
import { h700 } from '@atlaskit/theme/typography';
/**
 * Provide a styled container for form headers.
 */
var FormHeaderWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  font-family: ", ";\n"], ["\n  font-family: ", ";\n"])), fontFamily());
/**
 * Provide a styled container for form header title.
 */
var FormHeaderTitle = styled.h2(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", ";\n  line-height: ", "px;\n  margin-right: ", "px;\n  margin-top: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n"], ["\n  ", ";\n  line-height: ", "px;\n  margin-right: ", "px;\n  margin-top: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n"])), h700, multiply(gridSize, 4), multiply(gridSize, 4));
/**
 * Provide a styled container for form header title.
 */
var FormHeaderDescription = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  margin-top: ", "px;\n"], ["\n  margin-top: ", "px;\n"])), gridSize);
/**
 * Provide a styled container for form header content.
 */
var FormHeaderContent = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  min-width: 100%;\n  margin-top: ", "px;\n"], ["\n  min-width: 100%;\n  margin-top: ", "px;\n"])), gridSize);
export default FormHeaderWrapper;
export { FormHeaderTitle, FormHeaderDescription, FormHeaderContent };
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
//# sourceMappingURL=FormHeader.js.map